module.exports = __webpack_public_path__ + "img/calcular-imposto.a2df8245.svg";